'use client';

/**
 * on PromotionBannerError or empty there should explicitly shown nothing despite of a small border top
 *
 * @returns Div with small border top
 */
export const PromotionBannerEmpty = () => (
  <div className="border-b-color-grey-light container border-b" />
);
